import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum K1893InvoiceTjsLineItemKeys {
  itemNumber = 'itemNumber',
  description = 'description',
  caseQtyOrdered = 'caseQtyOrdered',
  caseCost = 'caseCost',
  discountRate = 'discountRate',
  discountPrice = 'discountPrice',
  lineTotal = 'lineTotal',
}

export const k1893InvoiceTjsFileDataSchema = yup.object({
  issuer: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  recipient: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  invoiceNumber: yup.string().nullable().optional(),
  associatedReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  remittanceInstructions: yup
    .object({
      routingNumber: yup.string().nullable().optional(),
      accountNumber: yup.string().nullable().optional(),
      bankName: yup.string().nullable().optional(),
      bankAddress: yup.string().nullable().optional(),
      beneficiaryName: yup.string().nullable().optional(),
      beneficiaryAddress: yup.string().nullable().optional(),
      paymentLink: yup.string().nullable().optional(),
    })
    .required(),
  items: yup
    .array()
    .of(
      yup
        .object({
          [K1893InvoiceTjsLineItemKeys.itemNumber]: yup.number().nullable().optional(),
          [K1893InvoiceTjsLineItemKeys.description]: yup.string().nullable().optional(),
          [K1893InvoiceTjsLineItemKeys.caseQtyOrdered]: yup.string().nullable().optional(),
          [K1893InvoiceTjsLineItemKeys.caseCost]: yup.string().nullable().optional(),
          [K1893InvoiceTjsLineItemKeys.discountRate]: yup.string().nullable().optional(),
          [K1893InvoiceTjsLineItemKeys.discountPrice]: yup.string().nullable().optional(),
          [K1893InvoiceTjsLineItemKeys.lineTotal]: yup.string().nullable().optional(),
        })
        .required(),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
})

export type K1893InvoiceTjsFileData = yup.InferType<typeof k1893InvoiceTjsFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<K1893InvoiceTjsFileData>

export const k1893InvoiceTjsFileMappings: RequiredFileData = {
  issuer: {
    companyName: 'b9b5a8e5-3a6c-4e8f-b7ff-6a9ade9cfeb8',
    addressLine1: 'e7ed6dcd-e7c0-4c9f-a2e5-d1e7acfb3834',
    phoneNumber: '8e9ec447-1b30-4836-bc75-ae3dd6ab6cc3',
    emailAddress: 'e6a7a447-4bbd-4ae2-b96b-be0e60bfee1e',
  },
  recipient: {
    companyName: '0bada0ec-e466-47ff-91e4-dec2d9f3b2db',
    addressLine1: 'cdb11426-89fa-4f64-be30-f1ce95a41654',
    phoneNumber: 'b3a52d7f-a859-4e94-ab92-23f524272c34',
    emailAddress: '9d5a8b67-5b88-4b3b-84c5-5e1fe9aa07c3',
  },
  invoiceNumber: 'f1f1ac2c-cf98-4a23-a343-6aeeec06bda9',
  associatedReferenceNumber: '63b9819e-fbeb-46dc-80c4-02ac27d3aaa0',
  dateIssued: 'a1d18754-6d71-4cc5-b5ea-80b879bcd03e',
  dateDue: 'f9f2bb72-dd84-4e78-8cbd-d9e29b4a0481',
  paymentTerms: '33cdf1d7-f01e-47f3-bfc4-ca703bf33f53',
  freightTerms: '5b91c8ea-55b5-49ee-b844-b4bc4537712d',
  remittanceInstructions: {
    routingNumber: 'e718b3be-f8ba-4e5c-853a-08fb29ccb33d',
    accountNumber: '50b0c7fa-e9f3-407e-abe5-7f688e8db556',
    bankName: '6ac17d52-5a40-404e-a4fd-68ef359b7bff',
    bankAddress: 'c54cdf82-4c24-4e73-8eaa-c404afe95cd4',
    beneficiaryName: 'a65acc8d-4761-411e-93ec-a76af24284ce',
    beneficiaryAddress: '7d4bc7e3-6fc4-4538-b2bd-80e1c6c3c6e7',
    paymentLink: '7fe4efae-7ae2-4eee-a5fe-0d3fafb36a66',
  },
  items: [
    {
      itemNumber: null,
      description: '3d2e71c3-d52c-4696-b7f9-fcf5aac20a27',
      caseQtyOrdered: 'cc56cda8-b1c9-4b9f-95f7-06d74a5fb301',
      caseCost: 'b6aec19f-d7d5-4e22-9737-58bfccb4d3c5',
      discountRate: 'f1b0a2d4-3c5e-4f8b-8a7c-9d6e0f2f3b5c',
      discountPrice: null,
      lineTotal: null,
    },
  ],
  agreement: '7c6e4f11-2f71-438f-8d9e-30bf4cbce674',
  comments: 'd858d38f-68d9-4d9e-8b6e-3eab70d6be5d',
}
